import { transformCatalogProductResponse, transformProductOptions } from '../transformers/product/index.js';
import { transformBundleOptions } from '../transformers/bundleOptions/index.js';
import { transformConfigurableOptions } from '../transformers/configurableOptions/index.js';
import { transformCustomOptions } from '../transformers/customOptions/index.js';
import { transformGroupedOptions } from '../transformers/groupedOptions/index.js';
import { transformGiftCardOptions } from '../transformers/giftcardOptions/index.js';
import { transformCustomerAddressEasyReturnRequest } from '../transformers/customer/index.js';

const transformCrmCustomerMeReturnsResponse = (data)=>data.map((item)=>transformCrmCustomerMeReturnResponse(item));
const transformCrmCustomerMeReturnsV2Response = ({ count , items  })=>({
        count,
        items: items.map((item)=>transformCrmCustomerMeReturnResponse(item))
    });
const transformReturnItems = ({ id , condition , order_item_id , qty_approved , qty_authorized , qty_requested , qty_returned , reason , resolution , status , metadata , parent_sku , product_data , product_options , sku  })=>{
    const productData = transformCatalogProductResponse(product_data);
    const transformedMetadata = {
        configurableOptions: transformConfigurableOptions(metadata?.configurable_options, product_data?.variants),
        customOptions: transformCustomOptions(metadata?.custom_options),
        bundleOptions: transformBundleOptions(metadata?.bundle_options),
        groupedOptions: transformGroupedOptions(metadata?.grouped_options),
        giftcardOptions: transformGiftCardOptions(metadata?.giftcard_item_option, productData)
    };
    return {
        id,
        sku,
        parentSku: parent_sku,
        qtyRequested: qty_requested,
        orderItemId: order_item_id,
        qtyAuthorized: qty_authorized,
        qtyApproved: qty_approved,
        qtyReturned: qty_returned,
        reason,
        condition,
        resolution,
        status,
        metadata: transformedMetadata,
        productOptions: transformProductOptions(product_options, productData, transformedMetadata),
        productData
    };
};
const transformEasyReturnPickupAddress = ({ address_type , city , country_id , firstname , lastname , postcode , region_id , street , telephone  })=>({
        addressType: address_type,
        city,
        countryCode: country_id,
        firstname,
        lastname,
        postcode,
        regionId: region_id,
        street,
        telephone
    });
const transformCrmCustomerMeReturnResponse = ({ id , return_number , order_number , order_id , status , date_requested , customer_email , items , easy_return , easy_return_pickup_address , iban_for_return  })=>({
        id,
        number: return_number,
        orderNumber: order_number,
        orderId: order_id,
        status,
        createdAt: date_requested,
        email: customer_email,
        items: items.map((item)=>transformReturnItems(item)),
        easyReturn: easy_return,
        easyReturnAddress: easy_return_pickup_address ? transformEasyReturnPickupAddress(easy_return_pickup_address) : null,
        ibanForReturn: iban_for_return
    });
const transformReturnsItemsRequest = (items)=>items.map(({ orderItemId , qty , reason , condition , resolution , changeProductId , ibanForReturn  })=>({
            order_item_id: orderItemId,
            qty_requested: qty,
            reason,
            condition,
            resolution,
            change_product_id: changeProductId,
            iban_for_return: ibanForReturn
        }));
const transformCrmCustomerMeReturnsRequest = ({ orderId , items , easyReturn , easyReturnAddress , orderNumber  })=>({
        order_id: orderId,
        order_increment_id: orderNumber,
        items: transformReturnsItemsRequest(items),
        ...easyReturn && easyReturnAddress ? {
            easy_return: easyReturn,
            /*
				easy_return_pickup_address: transformCustomerAddressRequest(easyReturnAddress),
				*/ /**
				 * The problem is that crm/customer/me/returns/request and crm/customer/me/address need two different formats for the region field
				 * For this reason we can't use the same request transform
				 * Once they are uniformed, we can remove the following line and uncomment the previous one
				 */ easy_return_pickup_address: transformCustomerAddressEasyReturnRequest(easyReturnAddress)
        } : null
    });
const transformCrmCustomerMeReturnsEstimateRequest = ({ city , countryCode , items , postcode , regionId , region  })=>({
        city,
        country_id: countryCode,
        items: items.map(({ condition , orderItemId , reason , resolution , qty  })=>({
                condition,
                order_item_id: orderItemId,
                reason,
                resolution,
                qty_requested: qty
            })),
        postcode,
        ...region ? {
            region: {
                region
            }
        } : null,
        region_id: regionId
    });
const transformCrmCustomerMeReturnsTypeRequest = ({ items  })=>({
        items: items.map(({ orderItemId , resolution  })=>({
                order_item_id: orderItemId,
                resolution
            }))
    });
const transformCrmCustomerMeReturnsTypeResponse = (data)=>{
    const returnsType = [];
    for (const [key, value] of Object.entries(data)){
        value ? returnsType.push(key) : null;
    }
    return returnsType;
};

export { transformCrmCustomerMeReturnResponse, transformCrmCustomerMeReturnsEstimateRequest, transformCrmCustomerMeReturnsRequest, transformCrmCustomerMeReturnsResponse, transformCrmCustomerMeReturnsTypeRequest, transformCrmCustomerMeReturnsTypeResponse, transformCrmCustomerMeReturnsV2Response, transformReturnsItemsRequest };
